export default "__VITE_ASSET__BeB72N_S__"